import { Button } from "primereact/button";
import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import AddNewUserForm from "./AddNewUserForm";

function AddNewUser({ getAllUsers, companyId }) {
  const [showModal, setShowModal] = useState(false);

  const onCloseModal = () => {
    setShowModal(false);
  };
  return (
    <>
      <div className="Down__Btn">
        <Button
          onClick={() => setShowModal(true)}
          iconPos="right"
          label={"Add New User"}
          className="Btn__Dark"
        />
      </div>
      <Dialog
        visible={showModal}
        style={{ width: "70vw" }}
        onHide={onCloseModal}
      >
        <AddNewUserForm
          onCloseModal={onCloseModal}
          getAllUsers={getAllUsers}
          companyId={companyId}
        />
      </Dialog>
    </>
  );
}

export default AddNewUser;
